import { differenceInYears, isValid, parse } from "date-fns";

import type { SchedulerContext } from "@/types/scheduler-machine";

export function isPatientUnder18(context: SchedulerContext): boolean {
  const dob = context.patientData?.dateOfBirth;
  if (!dob) return false;
  const parsed = parse(dob, "MM/dd/yyyy", new Date());
  return differenceInYears(new Date(), parsed) < 18;
}

/**
 * Returns the patient's age from an "MM/dd/yyyy" DOB, or undefined when the DOB is
 * missing/unparseable. Callers can treat undefined as "not known" — that's what the
 * facility-locations API expects (patientAge is optional; omit rather than send zero).
 */
export function getPatientAge(dob: string | undefined | null): number | undefined {
  if (!dob) return undefined;
  const parsed = parse(dob, "MM/dd/yyyy", new Date());
  if (!isValid(parsed)) return undefined;
  return differenceInYears(new Date(), parsed);
}
